var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 28,
    viewBox: "0 0 89 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.000976562 18.6476C-0.000976562 13.5214 3.60754 10.1465 7.80053 10.1465C10.1893 10.1465 12.0253 11.2842 12.8956 12.4475L13.2832 10.53H16.7011V26.7524H13.3785L12.8956 24.7709C12.1206 25.9023 10.3163 27.1359 7.70523 27.1359C3.38518 27.1551 -0.000976562 23.5821 -0.000976562 18.6476ZM13.1561 18.6476C13.1561 15.5667 11.1867 13.4894 8.51207 13.4894C5.79933 13.4894 3.83625 15.6307 3.83625 18.6476C3.83625 21.6645 5.80568 23.8058 8.51207 23.8058C11.1867 23.8122 13.1561 21.7348 13.1561 18.6476Z",
    fill: "#4B27DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6816 1.72803H23.4553V12.6836C24.2939 11.2518 26.0982 10.1524 28.4234 10.1524C32.1336 10.1524 34.3571 12.5557 34.3571 16.7999V26.7647H30.5834V17.5797C30.5834 14.9846 29.3255 13.5529 27.229 13.5529C25.1961 13.5529 23.4553 15.3362 23.4553 19.1329V26.7583H19.6816V1.72803Z",
    fill: "#4B27DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2793 27.155C39.3112 27.155 36.1855 23.5884 36.1855 18.6859C36.1855 13.6875 39.4446 10.1528 44.2475 10.1528C49.4761 10.1528 52.1824 13.8856 52.1824 18.2001C52.1824 18.6539 52.1507 19.2356 52.0554 19.6638H39.8957C40.2832 22.5849 42.1193 23.8185 44.508 23.8185C46.541 23.8185 47.7671 22.815 48.5104 21.3832L51.6361 22.847C50.4417 25.3973 47.9577 27.155 44.2793 27.155ZM39.9592 16.9665H48.377C48.0848 14.5951 46.4076 13.2976 44.2475 13.2976C42.2463 13.2976 40.4421 14.365 39.9592 16.9665Z",
    fill: "#4B27DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.707 18.6476C53.707 13.5214 57.3155 10.1465 61.5085 10.1465C63.8973 10.1465 65.7333 11.2842 66.6037 12.4475L66.9912 10.53H70.4091V26.7524H67.0865L66.6037 24.7709C65.8286 25.9023 64.0243 27.1359 61.4132 27.1359C57.0932 27.1551 53.707 23.5821 53.707 18.6476ZM66.8641 18.6476C66.8641 15.5667 64.8947 13.4894 62.2201 13.4894C59.5073 13.4894 57.5443 15.6307 57.5443 18.6476C57.5443 21.6645 59.5137 23.8058 62.2201 23.8058C64.8947 23.8122 66.8641 21.7348 66.8641 18.6476Z",
    fill: "#4B27DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0598 27.1546C75.708 27.1546 72.29 23.6839 72.29 18.6535C72.29 13.4314 75.9303 10.1524 80.1932 10.1524C82.6455 10.1524 84.4179 11.3541 85.2248 12.5557V1.72803H88.9985V26.7647H85.7711L85.3518 24.5595C84.4815 25.9146 82.4803 27.1546 80.0598 27.1546ZM76.0955 18.6471C76.0955 21.6321 78.0967 23.7734 80.8031 23.7734C83.4777 23.7734 85.4471 21.696 85.4471 18.6471C85.4471 15.5982 83.4777 13.5209 80.8031 13.5209C78.0967 13.5209 76.0955 15.6685 76.0955 18.6471Z",
    fill: "#4B27DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.ff4a6a4c70cade4b5e309b2c1e470fe5.svg";
export { ForwardRef as ReactComponent };